import { render, staticRenderFns } from "./UiTab.vue?vue&type=template&id=7be57053&"
import script from "./UiTab.vue?vue&type=script&lang=js&"
export * from "./UiTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports